import { render } from "./SaveProjectCategory.vue?vue&type=template&id=2bc404f6"
import script from "./SaveProjectCategory.vue?vue&type=script&lang=js"
export * from "./SaveProjectCategory.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__